import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { ErrorResponse } from '@/common/types/errorResponse';
import { AxiosResponse } from 'axios';

interface UseBlockClientCardProps {
  cardId?: string;
  onSuccess?: (reponse: AxiosResponse) => void;
  onError?: (error: ErrorResponse) => void;
}

const useBlockClientCard = ({ cardId, onSuccess, onError }: UseBlockClientCardProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation<AxiosResponse, ErrorResponse>({
    mutationKey: ['blockClientCard', cardId],
    mutationFn: () => privateAxios.put(`/client/cards/${cardId}/block`),
    onSuccess,
    onError,
  });
};

export default useBlockClientCard;
